import { createContext, useContext } from 'react';

import { FEATURE } from '@app/constants';

export interface FeatureFlag {
  name: FEATURE;
  isActive: boolean;
  config?: Record<string, string | boolean>;
}

export const FeatureFlagsContext = createContext<FeatureFlag[]>(null!);

export const useFeatureFlagsContext = (): FeatureFlag[] =>
  useContext(FeatureFlagsContext);
